import { Col, Row, Typography } from "antd";
import lodash from "lodash";
import React from "react";

const { Text } = Typography;
const IncomeStaffServiceList = ({ record }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  const renderSeviceList = () => {
    const services = record?.services || [];
    const extraServices = record?.extraServices || [];
    const allServices = [...services, ...extraServices];
    return allServices?.map((service, index) => {
      const name =
        service.name.length > 20
          ? `${index + 1}. ${lodash.slice(service.name, 0, 20).join("")}...`
          : `${index + 1}. ${service.name}`;
      return (
        <Col span={24} align="left" key={index}>
          <Row gutter={[5, 5]} justify="space-between" >
            <Col>
              <Text>{name}</Text>
            </Col>
            <Col align="right">
              <Text>{`$${service?.price}`}</Text>
              <Text code>x{service?.quantity}</Text>
            </Col>
          </Row>
        </Col>
      );
    });
  };
  // -------------------------- MAIN --------------------------
  if (record) {
    return (
      <Col span={24}>
        <Row justify={[20, 20]}>
          <Col span={6}>Services: </Col>
          <Col span={18}>{renderSeviceList()}</Col>
        </Row>
      </Col>
    );
  }
  return null;
};
export default IncomeStaffServiceList;
